<div id="forgetpassword" fxLayout="column">
    <div id="forgetpassword-form-wrapper" fxLayout="column" fxLayoutAlign="center center">
        <div id="forgetpassword-form" [@animate]="{value:'*',params:{duration:'300ms',y:'100px'}}">
            <div class="logo">
                <img src="../../../../assets/images/logo/giant2.png">
            </div>
            <div class="title">Forgot password</div>
            <div class="title">Please provide new password</div>
            
            <form name="forgetpasswordForm" [formGroup]="forgetpasswordForm" novalidate>

                <mat-form-field appearance="outline">
                    <mat-label>User Name</mat-label>
                    <input matInput type="text" formControlName="username">
                    <mat-icon matSuffix class="secondary-text">person</mat-icon>
                </mat-form-field>
                <mat-form-field appearance="outline">
                    <mat-label>Password</mat-label>
                    <input matInput type="password" formControlName="password">
                    <mat-icon matSuffix class="secondary-text">vpn_key</mat-icon>
                </mat-form-field>

                <mat-form-field appearance="outline">
                    <mat-label>Re-Enter password</mat-label>
                    <input matInput type="password" formControlName="ReEnterPassword">
                    <mat-icon matSuffix class="secondary-text">vpn_key</mat-icon>
                </mat-form-field>

                <button mat-raised-button color="accent" class="submit-button" aria-label="Forget password" [disabled]="forgetpasswordForm.invalid" (click)="VerifyUserEmail(forgetpasswordForm)">
                    Submit
                </button>
            </form>
        </div>
    </div>
</div>
